import React from 'react';

const DiagsPresence = ({ hasDiags, setHasDiags }) => {
  return (
    <div className='flex flex-col gap-6'>
      <p className='h2'>Avez-vous des diagnostics datés de moins de 6 mois ?</p>
      
      <p>Diagnostics obligatoires : Loi Carrez, DPE, ERP, Electricité, Gaz, Plomb, Amiante, Termites.</p>

      <div className='flex flex-col gap-3'>
        <div className={`flex items-center gap-3 border ${hasDiags === true ? 'border-ih-blue' : 'border-ih-blue-30'} rounded-2xl p-5 bg-white cursor-pointer`} onClick={() => setHasDiags(true)}>
          <div className='w-max'>
            <div className={`w-6 h-6 rounded-full border border-ih-blue-30 ${hasDiags === true && 'bg-ih-blue'}`}></div>
          </div>
          <p className='text-sm font-semibold'>Oui, j'ai tous les diagnostics obligatoires (datés de moins de 6 mois)</p>
        </div>

        <div className={`flex items-center gap-3 border ${hasDiags === false ? 'border-ih-blue' : 'border-ih-blue-30'} rounded-2xl p-5 bg-white cursor-pointer`} onClick={() => setHasDiags(false)}>
          <div className='w-max'>
            <div className={`w-6 h-6 rounded-full border border-ih-blue-30 ${hasDiags === false && 'bg-ih-blue'}`}></div>
          </div>
          <p className='text-sm font-semibold'>Non, il me manque des diagnostics</p>
        </div>
      </div>
    </div>
  )
}

export default DiagsPresence;
